import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 37px 30px 0 30px;
`

export const Divider = styled.div`
  margin: 20px;
`
